import { render, staticRenderFns } from "./UserConfigsMenu.vue?vue&type=template&id=5c4b8ffe&scoped=true&"
import script from "./UserConfigsMenu.vue?vue&type=script&lang=js&"
export * from "./UserConfigsMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserConfigsMenu.vue?vue&type=style&index=0&id=5c4b8ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b8ffe",
  null
  
)

export default component.exports